import script from "./IndustryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndustryView.vue?vue&type=script&setup=true&lang=ts"

import "./IndustryView.vue?vue&type=style&index=0&id=30fb06d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fb06d6"]])

export default __exports__